import type { CollectionUUID } from '@library/menu-service'

import type { MenuCollectionsState } from 'reducers/menu-collections/menuCollections'

export const getCollection = (id: CollectionUUID | null) => (state: MenuCollectionsState) => {
  if (!id || !state.menuV3Collections) {
    return null
  }

  return state.menuV3Collections.collections[id] || null
}
